import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { FC, useState, ReactNode } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Flex } from "../../Flex/flex.component";
import { FaChevronDown } from "react-icons/fa";
import { Button } from "../Button/button.scomponent";
import { Tag } from "../../Tag/tag.component";
import { normalizeOrderProductionStatus } from "../../../utils/normalizeProductionStatus";
import { ServiceOrderStageEnum, ServiceOrderStatusEnum } from "../../../Services/api/service-orders/service-order.interface";
import { normalizeFinancialStatusTitle } from "../../../utils/normalizeFinancialStatus";
import { normalizeOrderProductionStage } from "../../../utils/normalizeProductionStages";

interface IButtonStepMenuProps {
    options: {
        label: string;
        labelColor?: string;
        value: ServiceOrderStatusEnum | ServiceOrderStageEnum
        icon?: ReactNode;
        iconColor?: string;
    }[];
    type: 'status' | 'stage'
    mainIconColor?: string;
    initialLabel?: string;
    initialValue?: ServiceOrderStatusEnum | ServiceOrderStageEnum;
    onChange: ( data : { status: ServiceOrderStatusEnum | ServiceOrderStageEnum, productId: string }) => void;
    serviceOrderProductId: string
    readonly?: boolean
}

const ButtonStepMenu : FC<IButtonStepMenuProps> = ({ options, mainIconColor, initialLabel, initialValue, onChange, serviceOrderProductId, type, readonly }) => {
  const [step, setStep] = useState<string>(initialLabel || '')
  const [value, setValue] = useState<ServiceOrderStatusEnum | ServiceOrderStageEnum>(initialValue || ServiceOrderStatusEnum.INITIAL)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleCloseMenu = () => {
      setAnchorEl(null);
    };
  
    return (
      <>
      <Button variant='text' onClick={handleOpenMenu} sx={{ color: mainIconColor, height: '100%', width: '100%', flex: 1 }}>
        <Flex alignItems='center' justifyContent='center' gap='10px' sx={{ backgroundColor: type === 'status' ? normalizeOrderProductionStatus(value as ServiceOrderStatusEnum)?.bgColor : normalizeOrderProductionStage(value as ServiceOrderStageEnum)?.bgColor, width: '100%', padding: '10px 20px', borderRadius: '5px', flex: 1 }} width='100%'>
            <Typography fontSize={'14px'} color={type === 'status' ? normalizeOrderProductionStatus(value as ServiceOrderStatusEnum)?.textColor : normalizeOrderProductionStage(value as ServiceOrderStageEnum)?.textColor} sx={{ width: '100%', flex: 1 }}>{step}</Typography>
            {!readonly && <FaChevronDown color={type === 'status' ? normalizeOrderProductionStatus(value as ServiceOrderStatusEnum)?.textColor : normalizeOrderProductionStage(value as ServiceOrderStageEnum)?.textColor} />}  
          </Flex>
          {/* <Tag title={String(initialLabel)} boxStyle={{ backgroundColor: normalizeOrderProductionStatus(value)?.bgColor, width: '100%' }} wrapperStyle={{ width: '100%' }} titleStyle={{ color: normalizeOrderProductionStatus(value)?.textColor, fontSize: '15px' }} /> */}
      </Button>
       {!readonly && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
            {options.map((item, index) => (
                    <MenuItem 
                        key={index}
                        onClick={(e) => {
                            onChange({ status: item.value as ServiceOrderStatusEnum, productId: serviceOrderProductId })
                            handleCloseMenu()
                            setStep(item.label)
                            setValue(item.value as ServiceOrderStatusEnum)
                        }}
                        sx={{ color: item.labelColor }}
                    >
                        {item.icon && (
                            <span style={{ marginRight: '8px', display: 'flex', alignItems: 'center', color: item.iconColor }}>
                                {item.icon}
                            </span>
                        )}
                        {item.label}
                    </MenuItem>
            ))}
        </Menu>
      )}
      </>
    );
  };

  export { ButtonStepMenu }